import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ade8347"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-calendar-ticket-header__label" }
const _hoisted_2 = { class: "widget-calendar-ticket-header__label--small" }
const _hoisted_3 = { class: "widget-calendar-ticket-header__label--large" }

import { computed, PropType } from 'vue'
import {
  ITicketItemDateAvailability,
  ITicketItemDateAvailabilityTimeslot,
} from '@/models/service/serviceTicket.model'
import { formatCurrency } from '@/utils/formatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetTicketHeader',
  props: {
  ticketAvailabilities: {
    type: Array as PropType<ITicketItemDateAvailability[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props



const timeslots = computed<ITicketItemDateAvailabilityTimeslot[]>(() =>
  props.ticketAvailabilities.flatMap(
    (availability: ITicketItemDateAvailability) => availability.timeslots,
  ),
)

const getTimeslotLabel = (timeslot: ITicketItemDateAvailabilityTimeslot) =>
  formatCurrency(timeslot.price)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "widget-calendar-ticket-header__wrapper",
    style: _normalizeStyle(`grid-template-columns: repeat(${_unref(timeslots).length}, minmax(0, 1fr));`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ticketAvailabilities, (availability) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: availability.ticket_item
      }, [
        (availability.timeslots.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "widget-calendar-ticket-header__title",
              style: _normalizeStyle(`grid-column: span ${availability.timeslots.length};`)
            }, _toDisplayString(availability.name), 5))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeslots), (timeslot) => {
      return (_openBlock(), _createElementBlock("div", {
        key: timeslot.id,
        class: "widget-calendar-ticket-header__label-wrapper"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(getTimeslotLabel(timeslot)), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(getTimeslotLabel(timeslot)), 1)
        ])
      ]))
    }), 128))
  ], 4))
}
}

})